export default {
      id: "hazardous-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#hazardous",
      toString: function () {
        return this.url;
      }
    }